var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 16C28.0001 16.2652 27.8947 16.5196 27.7072 16.7071C27.5196 16.8947 27.2653 17 27.0001 17H7.4138L14.7076 24.2925C14.8005 24.3854 14.8742 24.4957 14.9244 24.6171C14.9747 24.7385 15.0006 24.8686 15.0006 25C15.0006 25.1314 14.9747 25.2615 14.9244 25.3829C14.8742 25.5043 14.8005 25.6146 14.7076 25.7075C14.6146 25.8004 14.5043 25.8741 14.383 25.9244C14.2616 25.9747 14.1314 26.0006 14.0001 26.0006C13.8687 26.0006 13.7386 25.9747 13.6172 25.9244C13.4958 25.8741 13.3855 25.8004 13.2926 25.7075L4.29255 16.7075C4.19958 16.6146 4.12582 16.5043 4.07549 16.3829C4.02517 16.2615 3.99927 16.1314 3.99927 16C3.99927 15.8686 4.02517 15.7385 4.07549 15.6171C4.12582 15.4957 4.19958 15.3854 4.29255 15.2925L13.2926 6.29251C13.4802 6.10487 13.7347 5.99945 14.0001 5.99945C14.2654 5.99945 14.5199 6.10487 14.7076 6.29251C14.8952 6.48015 15.0006 6.73464 15.0006 7.00001C15.0006 7.26537 14.8952 7.51987 14.7076 7.70751L7.4138 15H27.0001C27.2653 15 27.5196 15.1054 27.7072 15.2929C27.8947 15.4804 28.0001 15.7348 28.0001 16Z",
    fill: "#2A2420"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.4b19bf3b486306290e1bdacc722ec19a.svg";
export { ForwardRef as ReactComponent };